<header class="app-header">
  <div class="header-left">
    <nav class="menu desktop-menu" aria-label="Navegação principal">
      <button class="menu-item" [class.active]="activeMenuItem === 'dashboard'" (click)="navigateToDashboard()">
        <mat-icon class="menu-icon backoffice-icon backoffice-icon-medium">dashboard</mat-icon>
        <span>Visão Geral</span>
      </button>
      <button class="menu-item" [class.active]="activeMenuItem === 'participantes'" (click)="navigateToParticipantes()">
        <mat-icon class="menu-icon backoffice-icon backoffice-icon-medium">groups</mat-icon>
        <span>Participantes</span>
      </button>
      <button class="menu-item" [class.active]="activeMenuItem === 'relatorios'" (click)="navigateToRelatorios()">
        <mat-icon class="menu-icon backoffice-icon backoffice-icon-medium">bar_chart</mat-icon>
        <span>Relatórios</span>
      </button>
      @if (authViewModel.canAccessDocumentAnalysisLab()) {
        <button class="menu-item" [class.active]="activeMenuItem === 'laboratorio'" (click)="navigateToLaboratorio()" matTooltip="Laboratório & Co-Piloto de Análise Documental">
          <mat-icon class="menu-icon backoffice-icon backoffice-icon-medium">science</mat-icon>
          <span>Laboratório IA</span>
        </button>
      }
    </nav>

    <mat-form-field appearance="outline" class="compact-menu-field form-field-full filtro-field" subscriptSizing="dynamic">
      <mat-select
        [value]="activeMenuItem"
        aria-label="Navegação principal"
        (selectionChange)="onCompactMenuChange($event.value)"
      >
        <mat-option value="dashboard">
          <mat-icon class="backoffice-icon backoffice-icon-medium">dashboard</mat-icon>
          Visão Geral
        </mat-option>
        <mat-option value="participantes">
          <mat-icon class="backoffice-icon backoffice-icon-medium">groups</mat-icon>
          Participantes
        </mat-option>
        <mat-option value="relatorios">
          <mat-icon class="backoffice-icon backoffice-icon-medium">bar_chart</mat-icon>
          Relatórios
        </mat-option>
        @if (authViewModel.canAccessDocumentAnalysisLab()) {
          <mat-option value="laboratorio">
            <mat-icon class="backoffice-icon backoffice-icon-medium">science</mat-icon>
            Laboratório IA
          </mat-option>
        }
        @if (authViewModel.canAccessParameterization()) {
          <mat-option value="configuracoes">
            <mat-icon class="backoffice-icon backoffice-icon-medium">settings</mat-icon>
            Configurações
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="header-center">
    <div class="search-box">
      <input type="text" placeholder="Buscar por nome, CPF ou matrícula" />
      <mat-icon class="search-icon backoffice-icon backoffice-icon-small">search</mat-icon>
    </div>
  </div>

  <div class="header-right">
    <nav class="menu">
      @if (authViewModel.canAccessParameterization()) {
        <button
          class="menu-item config-menu-item"
          [class.active]="activeMenuItem === 'configuracoes'"
          (click)="navigateToParametros()"
          aria-label="Configurações"
          matTooltip="Configurações"
        >
          <mat-icon class="config-icon backoffice-icon backoffice-icon-medium">settings</mat-icon>
          <span class="config-label">Configurações</span>
        </button>
      }
    </nav>
  </div>
</header>
